import React from 'react';
import {
  Box,
  Paper,
  Typography,
} from '@mui/material';
import { AutoAwesome as AutoAwesomeIcon } from '@mui/icons-material';

const N8NAutomation: React.FC = () => {
  return (
    <Box>
      <Box sx={{ mb: 3, display: 'flex', alignItems: 'center', gap: 2 }}>
        <AutoAwesomeIcon sx={{ fontSize: 32, color: 'secondary.main' }} />
        <Typography variant="h4" sx={{ fontWeight: 700 }}>
          Automação N8N
        </Typography>
      </Box>

      <Paper sx={{ p: 3 }}>
        <Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>
          Em desenvolvimento...
        </Typography>
      </Paper>
    </Box>
  );
};

export default N8NAutomation;

